import { useCallback, useState } from 'react'

import { validatePhone } from '@/utils/phone'

/** Submit-time phone validation for forms that manage their own state. */
export function usePhoneField({ required = false }: { required?: boolean } = {}) {
  const [error, setError] = useState<string>()

  const clear = useCallback(() => setError(undefined), [])

  /** Returns true when the number passes; records the message when it doesn't. */
  const check = useCallback(
    (value: string | null | undefined) => {
      const message = validatePhone(value, { required })
      setError(message)
      return !message
    },
    [required]
  )

  return { error, clear, check }
}
